import React from "react";
import Slider from "react-slick";
import { Box } from "@mui/material";

const AutoPhotoSlider = ({ slides }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000, // Change every 4 seconds
    arrows: false, // Hide arrows if you prefer dots only
  };

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "hidden", zIndex:-1}}>
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              width: '100%',
              height:'100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <img
              src={slide.image}
              alt={slide.title}
              style={{
                width: '100%',
                height: '100%',
                maxHeight: '100vh',
                objectFit: 'cover', 
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default AutoPhotoSlider;